import React from 'react';
import { Redirect  } from "react-router-dom";


class ModalOrderConfirmation extends React.Component {

    state = {
        redirect: null,
        IsCouplingRooms:false,
        HasConnectionDoor:false,
        makeOrderData:null,
        HotelName:'',
        StartVacationDateFormatted:'',
        RoomsNum:''
    }

    componentDidMount() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });

            console.log('ModalOrderConfirmation componentDidMount props: ', this.props);  
            const { makeOrderData } = this.props;

            
            this.setState({ makeOrderData: makeOrderData });
            if (makeOrderData) {
                this.setState({ HotelName: makeOrderData.hotelForOrder.HotelName });
                this.setState({ StartVacationDateFormatted: makeOrderData.hotelForOrder.StartVacationDateFormatted });
                this.setState({ RoomsNum: makeOrderData.hotelForOrder.RoomsNum });
            }
    }




    backHomePage = () => {
        this.setState({ redirect: "/" }); 
    }


    setModalOrderConfirmationClosed = () =>  {
        this.setState({ redirect: "/" }); 
    }
    

  render() {

    
    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    } 
    
  
    
    

    return (

            <div className="cntered-flex">
                <React.Fragment >      
                    <div className="modal_main_bg2" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_confirmation_bg">

                            <div className="close_arrow pointer zindex1000" onClick={this.setModalOrderConfirmationClosed}></div>

                            <div className="modal_order_inner_bg">
                              
                                    <div className="modal_order_top">                            
                                        <div className="modal_order_title1"> אישור הזמנה</div>
                                    </div>


                                    <div className="modal_order_title_hotel directionRtl">
                                    הזמנתך נקלטה בהצלחה.
                                    </div>



                                    <div className="cntered-flex order_cancel_text directionRtl">
                                        מס הזמנה:
                                        &nbsp;
                                        {this.props.makeOrderDataResult.orderId}
                                        <br />

                                        מס שובר של ספק:
                                        &nbsp;
                                        {this.props.makeOrderDataResult.VoucherNumber}
                                        <br />

                                        מלון:
                                        &nbsp;
                                        {this.state.HotelName}
                                        <br />
                                        תאריך:
                                        &nbsp;
                                        {this.state.StartVacationDateFormatted}
                                        <br />
                                        מספר חדרים:
                                        &nbsp;
                                        {this.state.RoomsNum}
                                        <br />

                                        ספק:
                                        &nbsp;
                                        {this.props.makeOrderDataResult.SupplierName}
                                        <br />
                                    </div>

                                    <div className="modal_order_title_hotel directionRtl">

                                        
                                    מסרון אישור ההזמנה נשלח אליך
                                    </div>






                                <div className="modal_order_confirmation_container">
                                
                                    <div className="cntered-flex marginTop20">
                                        <div className="hp_search_main_button"
                                                onClick={() => this.backHomePage()}>
                                            <span className="hp_search_main_button_title">
                                            חזרה לדף הראשי
                                            </span>
                                        </div>
                                    </div>
                                            
                                </div>

                            </div>

                        </div>
                    </div>                
                </React.Fragment>
            </div>
    );
  }
}



export default ModalOrderConfirmation;